import i18next from 'i18next';

i18next.addResources('es', 'Information', {
  subscriptionType: 'Tipo de suscripción',
  users: 'Usuarios',
  paymentMethod: 'Medio de pago actual',
  nextPaymentDate: 'Próxima fecha de pago'
});
